export default __webpack_public_path__ + "static/media/food-and-drink.2385b4b5.svg";